module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/core-js/library/modules/_add-to-unscopables.js
// module id = 780
// module chunks = 0